export enum TriStateRange {
  Full = 'Full',
  Partial = 'Partial',
  None = 'None'
}
